module.exports = __webpack_public_path__ + "static/media/foods_unselected.a0188d20.svg";